// Recovered compiled webpack factory 43933. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      prefetchQueue: function () {
        return o;
      },
      prefetchReducer: function () {
        return i;
      },
    }));
  let n = r(79889),
    a = r(83571),
    o = new n.PromiseQueue(5),
    i = function (e, t) {
      (0, a.prunePrefetchCache)(e.prefetchCache);
      let { url: r } = t;
      return (
        (0, a.getOrCreatePrefetchCacheEntry)({
          url: r,
          nextUrl: e.nextUrl,
          prefetchCache: e.prefetchCache,
          kind: t.kind,
          tree: e.tree,
          allowAliasing: !0,
        }),
        e
      );
    };
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
